import React, { Component } from "react";
import GetTime from "../../GetTime.js";
class TripDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    this.getRunningDelay();
  }
  getRunningDelay() {
    let { trip_started, route_time_min } = this.props.tripDetailView;
    let runningdelay = new Date(trip_started);
    this.setState({ runningdelay: 12 });
  }
  render() {
    const tripdata = this.props.tripDetailView;

    return (
      <div className="trip_detail_container px-2 py-3">
        <div className="container">
          <span className="trip_detail_title">Trip Details</span>
          <table className="row">
            <tbody>
              <tr className="w-100 d-inline-block px-3">
                <td className="trip_detail_info py-2">
                  Assigned Date
                  <p>
                    <GetTime date={tripdata.assigned_date} />
                  </p>
                </td>
                <td className="trip_detail_info py-2">
                  Assigned Time
                  <p>{tripdata.assigned_time}</p>
                </td>
                <td className="trip_detail_info py-2">
                  Trip Started
                  <p>{tripdata.trip_started}</p>
                </td>
              </tr>
              <tr className="w-100 d-inline-block px-3">
                <td className="trip_detail_info py-2">
                  Total Orders
                  <p>{tripdata.total_orders}</p>
                </td>
                <td className="trip_detail_info py-2">
                  Total Bags
                  <p>{tripdata.box}</p>
                </td>
                <td className="trip_detail_info py-2">
                  Total Weight
                  <p>{tripdata.total_order_weight} kg</p>
                </td>
              </tr>
              <tr className="w-100 d-inline-block px-3">
                <td className="trip_detail_info py-2">
                  Trip Distance
                  <p>{tripdata.trip_distance}</p>
                </td>
                <td className="trip_detail_info py-2">
                  Ex. Trip Time
                  <p>{tripdata.exptected_trip_time}</p>
                </td>
                <td className="trip_detail_info py-2">
                  Running Delay
                  <p>
                    <GetTime time={tripdata.running_delay} />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
export default TripDetail;



// WEBPACK FOOTER //
// ./src/components/Intransit/ViewTripList/TripDetail.js